<template>
  <div id="hres4ax-popup1-tab2" class="panel box-collapse border-color-skin">
    <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#popup1tab2">
      <h3 class="box-title">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRES4AXC4']['200'] }}
      </h3>
    </div>
    <div id="popup1tab2" class="panel-collapse collapse tab-detail">
      <div class="panel-body">
        <div class="detail detail-responsive panel-detail-filter">
          <hrms-table :columns="popup1Tab2Table" 
                      :data="data"
                      :searchDisp="false"  />
        </div>
      </div>
      <div class="modal-footer" >
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'hres4ax-popup1-tab2',
  props: [ 'labels', 'data', 'popup1Tab2Table' ]
}
</script>


// WEBPACK FOOTER //
// popup1Tab2.vue?b3014d62